import { render, staticRenderFns } from "./NoLogin.vue?vue&type=template&id=01308a8c&scoped=true&"
import script from "./NoLogin.vue?vue&type=script&lang=js&"
export * from "./NoLogin.vue?vue&type=script&lang=js&"
import style0 from "./NoLogin.vue?vue&type=style&index=0&id=01308a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01308a8c",
  null
  
)

export default component.exports